module.exports = "https://cb-static.prod-my.games/promo/twitchregionselect/img/cb-logo.20731766.svg";